import axios from '@/utils/request'

// 获取地区
export function getCountrys() {
  return axios({
    url: '/country/list',
    method: 'get'
  })
}
